import Point from "./Point";

export default SVGPath;
type SVGPath = string;

// TODO: Add unit test. This used to not work because the path length was too
// small, there may be other corner cases that need to be tested.
const PATH_LENGTH = 1000;
export function getPointAtLengthFraction(
  path: SVGPath,
  fraction: number
): Point {
  const { x, y } = createPathElement(path).getPointAtLength(
    fraction * PATH_LENGTH
  );
  return { x, y };
}

export function getBBox(path: SVGPath): DOMRect {
  // We can only get the bounding box if the element is in the DOM.
  //
  // This notebook demonstrates the technique:
  // https://observablehq.com/@rlesser/automatic-getbbox.
  //
  // This answer adds code to prevent reflows (presumably more important if
  // this function is called in a tight loop or event handler):
  // https://stackoverflow.com/a/69801747/237285
  const svgElement = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "svg"
  );
  const pathElement = createPathElement(path);
  svgElement.appendChild(pathElement);

  // Prevent reflows. NOTE: Not sure if this is necessary, since the element is
  // removed before JavaScript yields to the browser.
  svgElement.style.visibility = "hidden";
  svgElement.style.position = "absolute";
  svgElement.style.top = "0";
  svgElement.style.left = "-1px";
  svgElement.style.width = "1px !important";
  svgElement.style.height = "1px !important";
  svgElement.style.overflow = "hidden";
  document.body.appendChild(svgElement);

  const bbox = pathElement.getBBox({ stroke: true });
  document.body.removeChild(svgElement);
  return bbox;
}

function createPathElement(path: string) {
  const pathElement = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "path"
  );
  pathElement.setAttribute("d", path);
  pathElement.setAttribute("stroke", "black");
  pathElement.setAttribute("stroke-width", "1");
  pathElement.setAttribute("path-length", PATH_LENGTH.toString());
  return pathElement;
}
